let url = window.location.href;
if (url.indexOf("?nl=welcome") != -1) {
	$("#m-newsletter-welcome").modal("show");
}